import React from "react";
import REVERSE_BODY_IMAGE from "../../../assets/v4-reports-assets/images/section-two/reserve-body-image.png";
import LOGO_ICON from "../../../assets/v4-reports-assets/icons/logo-icon.png";
import TM_LBLUE from "../../../assets/v4-reports-assets/icons/tm-logo-blue.png";
import WRITEUP from "../../../assets/v4-reports-assets/images/step 1.png";
import "./styles.scss";

const Section4 = ({ formData }) => {
  return (
    <>
      <section class="step___1">
        <div>
          <div>
            {formData?.available ? (
              <iframe
                title="AuthForm"
                width="100%"
                height="700px"
                src={`https://app.pandadoc.com/s/${formData.formId}`}
              ></iframe>
            ) : (
              <iframe
                title="AuthForm"
                width="100%"
                height="700px"
                src="https://eform.pandadoc.com/?eform=ff5234d6-78d3-47ee-b4e2-ed2f374fb997"
              ></iframe>
            )}
          </div>
        </div>
        <div style={{ paddingTop: "5rem" }}>
          <img src={WRITEUP} />
        </div>
      </section>
    </>
  );
};

export default Section4;

{
  /* <div class="grid-col-one">
<div style={{ padding: "10%" }}>
 
  )}
</div>
</div>
<div class="grid-col-two">
<img style={{ height: "100%", width: "auto" }} src={WRITEUP} /> */
}
{
  /* <div style={{ padding: "10%" }} class="column-container">
  <div class="column-header">
    <h1 class="column-header__number">01.</h1>
    <h4 class="column-header__title">
      Reserve an adjustment meeting
    </h4>
    <p class="column-header__caption">
      To report data-backed damage with one of our adjustment
      consultants
    </p>
  </div>

  <div class="column-body">
    <img src={REVERSE_BODY_IMAGE} alt="" class="column-body__image" />
  </div>

  <div class="column-action">
    <img src={LOGO_ICON} alt="" class="site-logo" />
    <p class="action">
      Damage Intelligence
      <img src={TM_LBLUE} alt="" class="tm-logo" />
    </p>
  </div>
</div>

*/
}
{
  /* </div> */
}
